import { SimpleXHREndpoint } from './constants';
export const getFakeResponse = (endpoint)=>(options)=>{
        if (process.env.NODE_ENV !== 'production') {
            switch(endpoint){
                case SimpleXHREndpoint.GIVE_POINTS_POPUP:
                    {
                        const response = {
                            pointsBalance: 10
                        };
                        return response;
                    }
                case SimpleXHREndpoint.GIVE_LLAMA:
                    {
                        const response = {}; // BE is returning redundant session
                        return response;
                    }
                case SimpleXHREndpoint.GIVE_POINTS:
                    {
                        const response = {
                            success: true
                        };
                        return response;
                    }
                default:
                    return;
            }
        }
    };
